module.exports = "//cdn.mxpnl.com/static/asset-cache/efdab309185ed2ff7cb36f904ccebee0/iron/common/assets/images/charts/stacked-bar.svg";